
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/ups-usa",
      function () {
        return require("private-next-pages/partners/ups-usa.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/ups-usa"])
      });
    }
  